import { combineReducers } from '@reduxjs/toolkit'
import settingSlice from '../features/setting/setting.slice.ts'
import { authApi } from '../apis/auth/auth.api.ts'
import { userSlice } from '../features/user/user.slice.ts'
import { tickerManagementApi } from '../apis/ticker-management/ticker-management-api.api.ts'
import { managementInputSlice } from './slices/management-input.slice.ts'
import { userManagementApi } from '../apis/user-management/user-management-api.api.ts'
import { optionApi } from '../apis/option/option-api.api.ts'
import { firmManagementApi } from '../apis/firm-management/firm-management-api.api.ts'
import { rankingInputSlice } from './slices/ranking-input.slice.ts'
import { rankingApi } from '../apis/ranking/ranking-api.api.ts'
import { ideaListInputSlice } from './slices/idea-list-input.slice.ts'
import { ideaApi } from '../apis/idea/idea-api.api.ts'
import { tickerApi } from '../apis/ticker/ticker-api.api.ts'
import { bookApi } from '../apis/book/book-api.api.ts'
import { statisticsApi } from '../apis/statistics/statistics-api.api.ts'
import { blockLeaveApi } from '../apis/block-leave/block-leave-api.api.ts'
import { dashboardInputSlice } from './slices/dashboard-input.slice.ts'

const appReducer = combineReducers({
  [authApi.reducerPath]: authApi.reducer,
  [bookApi.reducerPath]: bookApi.reducer,
  [ideaApi.reducerPath]: ideaApi.reducer,
  [tickerApi.reducerPath]: tickerApi.reducer,
  [statisticsApi.reducerPath]: statisticsApi.reducer,
  [rankingApi.reducerPath]: rankingApi.reducer,
  [tickerManagementApi.reducerPath]: tickerManagementApi.reducer,
  [userManagementApi.reducerPath]: userManagementApi.reducer,
  [firmManagementApi.reducerPath]: firmManagementApi.reducer,
  [optionApi.reducerPath]: optionApi.reducer,
  [blockLeaveApi.reducerPath]: blockLeaveApi.reducer,
  setting: settingSlice.reducer,
  user: userSlice.reducer,
  ideaListInput: ideaListInputSlice.reducer,
  managementInput: managementInputSlice.reducer,
  rankingInput: rankingInputSlice.reducer,
  dashboardInput: dashboardInputSlice.reducer,
})

export default appReducer
